import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './assets/global.css'
import { useAuthStore } from './stores/useAuthStore'
import { initializeUrlTracker } from './services/UrlTrackerService'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)

// Initialize auth store
const authStore = useAuthStore()
authStore.initialize().then(() => {
  app.mount('#app');

  // Initialize URL tracker for URL updates from parent window
  initializeUrlTracker()
});

